import {
    GET_PLAN,
    SET_PLAN_COVER,
    SET_PLAN_DESCRIPTION,
    UPDATE_PLAN,
    SHARE_PLAN,
    SET_PLAN_STATE_TO_IN_PUBLISH,
    REFRESH_PLAN,
    MOVE_TASK,
    ADD_TASK,
    REMOVE_TASK,
    RESET_PLAN,
    EDIT_TASK,
    REMOVE_TASK_PROP,
    CLEAR_TASK,
    SET_PLAN_META,
    PLAN_ACCEPTED,
    PLAN_DECLINED,
    CHANGE_PLAN_COPY,
    SET_PLAN_TITLE,
    ADD_NEW_SCORE,
    REMOVE_SCORE,
    EDIT_PLAN_SCORE,
    GENERATE_TASKS,
    GET_PLAN_META,
    REMOVE_AUDIO,
    ADD_AUDIO,
    ENABLE_EXPERIENCE_REQUEST,
    ENABLE_EXPERIENCE_SUCCESS,
    ENABLE_EXPERIENCE_FAILURE,
    SET_EXPERIENCE,
    CHANGE_TASK_DESCRIPTION,
} from "../types";

import { checkTasksPlayable } from "../../../../common/parameters";
import parseDescriptions from "../../../../common/helpers/parseDescriptions";
import { getScaleAndTempo } from "../../../../common/helpers/ref";
import { IPlanState } from "../models";
import { PlanActionTypes } from "../models/planActions";
import { IPlan } from "../../../../common/types";
import { isValidPlanDescription } from "../../../../common/validation";

export default (plan: IPlanState = null, action: PlanActionTypes): IPlanState => {
    let index, tasks, task, data;
    switch (action.type) {
        case GET_PLAN:
            if (action.payload.loading) {
                return { loading: true };
            }
            if (action.payload.error) {
                return { error: true, notFound: action.payload.notFound };
            }
            plan = { ...action.payload.data!.plan };
            break;
        case GET_PLAN_META:
            plan = { ...plan!, meta: action.payload.data };
            break;
        case SET_PLAN_DESCRIPTION:
            if (action.payload.data.success) {
                (plan as IPlan).description = parseDescriptions(action.payload.description);
                setModified(plan as IPlan);
                return { ...plan };
            }
            break;
        case SET_PLAN_TITLE:
            if (action.payload.data.success) {
                (plan as IPlan).name = action.payload.name;
                setModified(plan as IPlan);
                return { ...plan };
            }
            break;
        case SET_PLAN_COVER:
            if (action.payload.data.success) {
                (plan as IPlan).cover = action.payload.cover._id + action.payload.cover.ext;
                setModified(plan as IPlan);
                return { ...plan };
            }
            break;
        case SHARE_PLAN:
            data = action.payload.data;
            if (data.success) {
                (plan as IPlan).shared = true;
                (plan as IPlan).published = new Date().getTime();
                (plan as IPlan).publicId = data.publicId;
            }
            break;
        case SET_PLAN_STATE_TO_IN_PUBLISH:
            (plan as IPlan).public = true;
            break;
        case MOVE_TASK:
            tasks = (plan as IPlan).tasks;
            if (!action.payload.data.success) return plan;
            index = action.payload.index;
            tasks.splice(index + 1, 0, tasks.splice(index, 1)[0]);
            setModified(plan as IPlan);
            break;
        case ADD_TASK:
            tasks = (plan as IPlan).tasks;
            if (!action.payload.data.success) return plan;
            tasks.splice(action.payload.index, 0, {
                type: action.payload.taskType,
                data: {},
                id: action.payload.data.id,
            });
            setModified(plan as IPlan);
            break;
        case REMOVE_TASK:
            tasks = (plan as IPlan).tasks;
            if (!action.payload.data.success) return plan;
            const taskId = tasks[action.payload.index].id;
            const experiencePosition = (plan as IPlan).experience.positions.indexOf(taskId);
            if (experiencePosition !== -1) {
                (plan as IPlan).experience.positions[experiencePosition] = null;
            } else {
                (plan as IPlan).experience.positions = (plan as IPlan).experience.positions.map(position => {
                    if (Array.isArray(position)) {
                        if (position[0] === taskId) {
                            return position[1];
                        } else if (position[1] === taskId) {
                            return position[0];
                        }
                        return position;
                    }
                    return position;
                })
            }
            if ((plan as IPlan).experience.enabled && (plan as IPlan).experience.score === taskId) {
                (plan as IPlan).experience.score = undefined;
            }
            tasks.splice(action.payload.index, 1);
            if (action.payload.data.playable) {
                (plan as IPlan).playable = true;
            }
            setModified(plan as IPlan);
            break;
        case RESET_PLAN:
            return null;
        case EDIT_TASK:
            tasks = (plan as IPlan).tasks;
            task = tasks[action.payload.taskIndex];
            task.data = {
                ...task.data,
                [action.payload.changingProp]: action.payload.val,
            };
            if (action.payload.changingProp === "score" && task.ref) {
                task.data = {
                    ...task.data,
                    ...getScaleAndTempo((plan as IPlan), action.payload.taskIndex),
                }
                delete task.ref;
            }
            if (action.payload.changingProp === "boxes") {
                delete task.ref;
            }
            setModified(plan as IPlan);
            break;
        case REMOVE_TASK_PROP:
            tasks = (plan as IPlan).tasks;
            task = tasks[action.payload.taskIndex];
            delete (task.data as any)[action.payload.removingProp];
            setModified(plan as IPlan);
            break;
        case CLEAR_TASK:
            tasks = (plan as IPlan).tasks;
            task = tasks[action.payload.taskIndex];
            task.data = {};
            setModified(plan as IPlan);
            break;
        case SET_PLAN_META:
            ((plan as IPlan).meta[action.payload.cat] as any)[action.payload.prop] = action.payload.val;
            setModified(plan as IPlan);
            break;
        case UPDATE_PLAN:
            plan = action.payload;
            setModified(plan as IPlan);
            break;
        case REFRESH_PLAN:
            if (action.payload.data.success) {
                delete (plan as IPlan).refreshInProgress;
                (plan as IPlan).published = new Date().getTime();
                (plan as IPlan).accepted = false;
                return { ...plan };
            }
            break;
        case PLAN_ACCEPTED:
            if (plan && action.payload === (plan as IPlan).publicId) {
                (plan as IPlan).accepted = true;
            }
            break;
        case PLAN_DECLINED:
            if (plan && action.payload === (plan as IPlan).publicId) {
                delete (plan as IPlan).public;
            }
            break;
        case CHANGE_PLAN_COPY:
            if (plan && (plan as IPlan)._id === action.payload.planId) {
                (plan as IPlan).copyright = action.payload.copyright;
            }
            break;
        case ADD_NEW_SCORE:
            if (!(plan as IPlan).scores) (plan as IPlan).scores = [];
            (plan as IPlan).scores.push(action.payload);
            setModified(plan as IPlan);
            break;
        case EDIT_PLAN_SCORE:
            (plan as IPlan).scores[action.payload.index!] = action.payload;
            setModified(plan as IPlan);
            break;
        case REMOVE_SCORE:
            if ((plan as IPlan).experience.enabled && (plan as IPlan).experience.score === (plan as IPlan).scores[action.payload]._id) {
                (plan as IPlan).experience.score = undefined;
            }
            (plan as IPlan).scores.splice(action.payload, 1);
            setModified(plan as IPlan);
            break;
        case GENERATE_TASKS:
            (plan as IPlan).tasks.push(...action.payload);
            setModified(plan as IPlan);
            break;
        case ADD_AUDIO:
            (plan as IPlan).audio = action.payload;
            setModified(plan as IPlan);
            break;
        case REMOVE_AUDIO:
            delete (plan as IPlan).audio;
            break;
        case ENABLE_EXPERIENCE_REQUEST:
            (plan as IPlan).experienceLoading = true;
            break;
        case ENABLE_EXPERIENCE_SUCCESS:
            delete (plan as IPlan).experienceLoading;
            (plan as IPlan).experience = {
                enabled: true,
                positions: [],
            };
            setModified(plan as IPlan);
            break;
        case ENABLE_EXPERIENCE_FAILURE:
            delete (plan as IPlan).experienceLoading;
            break;
        case SET_EXPERIENCE: 
            (plan as IPlan).experience = action.payload;
            setModified(plan as IPlan);
            break;
        case CHANGE_TASK_DESCRIPTION:
            (plan as IPlan).tasks[action.payload.index].description = action.payload.description;
            setModified(plan as IPlan);
            break;
        default:
            return plan;
    }
    if (plan && (plan as IPlan).tasks) {
        const cPlan = plan as IPlan
        let sharable = checkTasksPlayable(cPlan.tasks, cPlan);
        if (cPlan.tasks.length === 0) {
            sharable = false;
            cPlan.playable = false;
        } else {
            cPlan.playable = true;
        }
        cPlan.sharable = sharable;
        let ok = false;
        if (cPlan.meta && cPlan.meta.opus && cPlan.meta.rhythm && cPlan.meta.teaching) {
            ok = true;
            if (!isValidPlanDescription(cPlan.description)) ok = false;
            // general
            if (!cPlan.meta.opus.planType) ok = false;
            if (cPlan.meta.opus.planType === "written") {
                if (!cPlan.meta.opus.composer) ok = false;
                if (!cPlan.meta.opus.title) ok = false;
                if (!cPlan.meta.opus.genre) ok = false;
            } else if (cPlan.meta.opus.planType === "folk") {
                if (!cPlan.meta.opus.title) ok = false;
                if (!cPlan.meta.opus.lyricLanguage) ok = false;
                if (!cPlan.meta.opus.folksongTempo) ok = false;
            } else if (cPlan.meta.opus.planType === "exercise") {
                if (!cPlan.meta.opus.exerciseType) ok = false;
            } else {
                ok = false;
            }

            // music
            if (!cPlan.meta.rhythm.tempo) ok = false;
            if (!cPlan.meta.rhythm.timeSignatureDen) ok = false;
            if (!cPlan.meta.rhythm.timeSignatureNum) ok = false;

            // teaching
            if (!cPlan.meta.teaching.level) ok = false;
        }
        cPlan.metaDone = ok;
    }
    return { ...plan };
};

const setModified = (plan: IPlan) => {
    plan.modified = new Date().getTime();
};
